// import React from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import parse from "html-react-parser";

function CardDetails({ card, onClose }) {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50 p-4">
      <div className="relative bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow-lg max-w-4xl w-full">
        {/* Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-3xl sm:text-4xl text-gray-500 hover:text-black"
        >
          <IoIosCloseCircleOutline />
        </button>

        {/* Content Section */}
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
          {/* Image Section */}
          <div className="w-full md:w-1/2">
            {card.images.length > 1 ? (
              <Slider {...sliderSettings}>
                {card.images.map((image, index) => (
                  <div key={index} className="w-full">
                    <img
                      src={image}
                      alt={card.alumniNews_title}
                      className="w-full h-[200px] sm:h-[250px] md:h-[300px] object-contain rounded-lg"
                    />
                  </div>
                ))}
              </Slider>
            ) : (
              <img
                src={card.images[0]}
                alt={card.alumniNews_title}
                className="w-full h-[200px] sm:h-[250px] md:h-[300px] object-contain rounded-lg"
              />
            )}
          </div>

          {/* Text Content */}
          <div className="w-full md:w-1/2">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 text-center md:text-left font-titillium">
              {card.alumniNews_title}
            </h2>
            <div
              className="text-gray-700 text-sm sm:text-base leading-relaxed text-center md:text-left overflow-auto font-inter"
              style={{ maxHeight: "150px" }} // Set max height for scrolling
            >
              {parse(card.alumniNews_description)}
            </div>
            {card.expandedContent && (
              <div
                className="text-gray-700 text-sm sm:text-base leading-relaxed mt-4 text-center md:text-left overflow-auto"
                style={{ maxHeight: "150px" }} // Set max height for scrolling
              >
                {parse(card.expandedContent)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardDetails;
